<script>
    import { createEventDispatcher } from 'svelte';
  
    // Initialize the dispatcher for sending events to the parent
    const dispatch = createEventDispatcher();
    let reason = '';
    export let requireReason = false;
    export let isSubmitting = false;

    // Function to handle submit
    function handleSubmit() {
      if (isSubmitting) return;
      if (requireReason && (!reason || reason.trim() === '')) {
        alert('Prašome įrašyti atšaukimo priežastį.');
        return;
      }
      // Emit the selected reason to the parent; parent will navigate on success
      dispatch('submit', { reason });
    }
  </script>
  
  <!-- Component markup -->
  <div>
    <textarea aria-label="Atšaukimo priežastis" maxlength="500" bind:value={reason} placeholder="Įrašykite atšaukimo priežastį..." rows="4"></textarea>
    <button on:click={handleSubmit} disabled={isSubmitting} aria-busy={isSubmitting} class="confirm-button">
      <span>{isSubmitting ? 'Atšaukiama...' : 'Patvirtinti'}</span>
    </button>
  </div>
<style>
  div{
    width:100%;
  }
  textarea {
    width: 100%;
    height: 100px;
    border: 1px solid #000000;
    
    /* Box shadow */
    box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16);
    
    /* Rounded corners */
    border-radius: 8px;

    /* Adjust the padding for better text visibility */
    padding: 10px;
    
    /* Optional: Set a font for better readability */
    font-family: Arial, sans-serif;
    font-size: 16px;
    resize: vertical; /* Allows the user to resize the textarea vertically */
}

  button span {
        font-weight: 700;
        font-size: 1rem;
    }

  .confirm-button {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 12px 20px;
        gap: 10px;

        width: 100%;
        height: 60px;

        /* Restore original orange styling */
        background-color: #fab45a;
        border: 1px solid #000000;
        color: #333;

        box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16);
        border-radius: 8px;

        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;

        outline: none;
        cursor: pointer;
        background-image: none;
    }

    .confirm-button:not(:disabled):hover {
      background-color: #927043;
      border-color: #000000;
    }

    button:disabled {
      /* Keep the pending state visible across action-button themes. */
      background-color: var(--cancellation-pending-background, #6b7280) !important;
      color: var(--cancellation-pending-color, #fff) !important;
      cursor: wait;
    }
</style>
